<template>

  <div class="bg-container page">
    <img class="bg-img" src="/img/login/login.jpg" onerror="this.src='/img/error.png'">
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()"/>
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <img src="/img/mine/nav10.png" onerror="this.src='/img/error.png'" />
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <!-- Logo -->
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" :src="siteLogo" :alt="siteName" @error="setDefaultLogo" />
            </div>
          </div>

<!--          <div class="title">{{$t("auth.register")}}</div>-->
          <div class="loginForm">
            <!-- 用户名 -->
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />

            <!-- 电话号码 -->
            <van-field
              v-model="phone"
              clearable
              input-align="center"
              class="input"
              type="tel"
              :placeholder="$t('auth.phone_place')"
            />

            <!-- 登录密码 -->
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')">
              <template slot="right-icon">
                <van-icon :name="passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
            </van-field>

            <!-- 再次输入登录密码 -->
            <van-field
              v-model="confirmPassword"
              :type="confirmPasswordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.confirm_pwd_place')">
              <template slot="right-icon">
                <van-icon :name="confirmPasswordType === 'password' ? 'closed-eye':'eye-o'" @click="switchConfirmPasswordType"/>
              </template>
            </van-field>

            <!-- 邀请码 -->
            <van-field
              v-model="code"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.invite_code_place')"
            />

            <!-- 去登录链接 -->
            <div @click="toLogin()" class="login-text">
              <span>{{$t("auth.has_account")}}</span>
            </div>

            <van-button class="login-btn" type="primary" size="normal" @click="doRegister()">{{$t("auth.register")}}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      phone: '',
      password: this.inputValue,
      confirmPassword: '',
      code: '',
      lang: 'en_us',
      passwordType: 'password',
      confirmPasswordType: 'password',
    };
  },
  computed: {
    baseInfo() {
      return this.$store.getters.getBaseInfo || {};
    },
    siteLogo() {
      return this.formatAssetUrl(this.baseInfo.ico, "/img/homenavlogo.png");
    },
    siteName() {
      return this.baseInfo.name || this.$t("my.title");
    },
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'en';
  },
  methods: {
    formatAssetUrl(url, fallback) {
      if (!url) {
        return fallback;
      }
      if (/^https?:\/\//i.test(url)) {
        return url;
      }
      return url.charAt(0) === "/" ? url : "/" + url;
    },
    setDefaultLogo(event) {
      event.target.src = "/img/error.png";
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchConfirmPasswordType() {
      this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    toLogin() {
      this.$router.push('/Login');
    },
    doRegister() {
      // 用户名验证
      if(!this.username || this.username.trim() === ''){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }

      // 电话号码验证
      if(!this.phone || this.phone.trim() === ''){
        this.$toast.fail(this.$t("auth.phone_place"));
        return false;
      }

      // 登录密码验证
      if(!this.password || this.password.length < 6 || this.password.length > 12){
        this.$toast.fail(this.$t("auth.pwd_length_error"));
        return false;
      }

      // 确认密码验证
      if(this.password !== this.confirmPassword){
        this.$toast.fail(this.$t("auth.pwd_not_match"));
        return false;
      }

      // 邀请码验证
      if(!this.code || this.code.trim() === ''){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      this.$http({
        method: 'post',
        data:{
          username: this.username.trim(),
          phone: this.phone.trim(),
          password: this.password,
          code: this.code.trim(),
          lang: this.lang
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token', res.data);
            this.$router.push("Mine");
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register{
  height: 100%;
}
.bg-container .bg-wrapper .register .nav-bar{
  background: 0 0
}

.language{
  position: absolute;
  top: 10px;
  right: 40px;
  height: 62px;

  img{
    height: 100%;
  }
}
.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper{
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.register .wrapper .title{
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.register .wrapper .loginForm{
  padding: 60px;
}
.register .wrapper .loginForm .input{
  padding: 10px 20px;
  margin-top: 35px;
  border-radius: 50px;
  text-align: center;
  line-height: 70px;
  font-size: 30px;
  color: #4e4e4e;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.register .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.register .wrapper .loginForm .reset-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.register .wrapper .loginForm .register-text{
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .register-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.register .wrapper .loginForm .login-text{
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .login-text span{
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.register .wrapper .loginForm .login-btn{
  margin-top: 30px;
  width: 100%;
  height: 100px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(90deg, #d51aac, #cc2996);;
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.register .wrapper .loginForm .agreement{
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .agreement .agreement-text{
  margin-left: 10px;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}
::v-deep .agreement .van-icon {
  font-size: 30px;
}
::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}
::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}
</style>
